export default __webpack_public_path__ + "static/harvest-finance-graphic-tilted-59dd79e14c84a10dd20c0803d8e7aa4e.svg";